"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiStepStyles = void 0;
var component_2023_utils_token_parser_1 = require("@rentspree/component-2023.utils.token-parser");
var activeSubtitleColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.active.subtitle-text.color');
var subtitleCommonStyle = {
    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.subtitle-text.color'),
    fontFamily: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.subtitle-text.font'),
    fontWeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.subtitle-text.weight'),
    fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.subtitle-text.size'),
    letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.subtitle-text.letter-spacing'),
    lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.subtitle-text.line-height'),
    marginTop: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.container.padding-bt-element'),
    padding: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-container.padding'),
    wordBreak: 'break-word',
    hyphens: 'auto',
};
exports.muiStepStyles = {
    styleOverrides: {
        root: {
            color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-container.color'),
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-container.height'),
            display: 'flex',
            alignItems: 'center',
            padding: '0 !important',
        },
        horizontal: {
            '> div': {
                width: 'min-content',
                height: '100%',
            },
            '& .MuiDivider-root': {
                margin: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.mobile.divider-container.padding'),
            },
            '& .MuiBox-root': {
                '& .RSPStepLabel-subtitle-complete': __assign({}, subtitleCommonStyle),
                '& .RSPStepLabel-subtitle-active': __assign(__assign({}, subtitleCommonStyle), { color: activeSubtitleColor }),
                '& .RSPStepLabel-subtitle-inactive': __assign({}, subtitleCommonStyle),
            },
        },
        vertical: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
            '& .MuiDivider-root': {
                margin: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.stepper.divider-container.padding'),
            },
            '> div': {
                width: '100%',
                height: '100%',
            },
            '& .MuiBox-root': {
                '& .RSPStepLabel-subtitle-complete': __assign({}, subtitleCommonStyle),
                '& .RSPStepLabel-subtitle-active': __assign(__assign({}, subtitleCommonStyle), { color: activeSubtitleColor }),
                '& .RSPStepLabel-subtitle-inactive': __assign({}, subtitleCommonStyle),
            },
        },
    },
};
//# sourceMappingURL=step.js.map